import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { KeyValueGeneratorService } from '@usimweb/core/services';

@Component({
    selector: 'usimweb-dropdown',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './dropdown.component.html',
    styleUrls: ['./dropdown.component.scss'],
    standalone: false
})
export class DropdownComponent implements OnInit, OnChanges {
  @Input() default: any = undefined;

  @Input() values: any = undefined;

  @Input() placeholder: string = '';

  @Input() required: boolean = false;

  @Input() key: string = '';

  @Input() value: string = '';

  @Input() width = '100%';

  @Input() isToolTip: boolean = false;

  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();

  @Output() formClicked: EventEmitter<any> = new EventEmitter<any>();

  public keyValueArray: any[] = [];

  constructor(private keyValueGenerator: KeyValueGeneratorService, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.keyValueArray = this.keyValueGenerator.generate(this.values, this.key, this.value) as any;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.keyValueArray = this.keyValueGenerator.generate(this.values, this.key, this.value) as any;

    if (changes['default'] && this.default) {
      this.default = changes['default'];
    }
  }

  public selectionChanged(value: string) {
    this.selectionChange.emit(value);
  }

  public compareWith(a: string, b: any): boolean {
    // console.log('a');
    // console.log(a);
    // console.log('b');
    // console.log(b);

    if (a && b) {
      return a === b.currentValue;
    }
    return false;
  }

  public deSelect() {
    this.default = undefined;
    this.cd.detectChanges();
  }

  public formClick() {
    this.formClicked.emit();
  }
}
